export * from './IconWellPresetALT';
